export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-primary-500">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
              尾巴漫画客户端
            </h2>
            <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-4">
              下载尾巴漫画APP，享受更流畅的下拉式阅读体验。支持离线下载、夜间模式、更新提醒等专属功能，
              随时随地畅读海量漫画。iOS与Android双平台覆盖，扫码即可下载。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-3 px-5 py-3 bg-background-50/15 backdrop-blur-sm rounded-xl border border-background-50/20">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-apple-line text-background-50 text-2xl"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-primary-100">下载</div>
                  <div className="text-sm font-medium text-background-50">App Store</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 bg-background-50/15 backdrop-blur-sm rounded-xl border border-background-50/20">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-android-line text-background-50 text-2xl"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-primary-100">下载</div>
                  <div className="text-sm font-medium text-background-50">Google Play</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 w-[200px]">
            <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20reading%20app%20interface%20with%20comic%20panels%20and%20Korean%20webtoon%20style%20art%2C%20clean%20UI%20design%20with%20warm%20orange%20accents%2C%20modern%20app%20screenshot%20style%2C%20vertical%20scrolling%20layout%2C%20soft%20gradient%20background%2C%20professional%20mockup%20presentation&width=600&height=800&seq=app-mockup-manga&orientation=portrait"
                alt="尾巴漫画APP界面"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}